import {use} from 'react'

import {Grid, Stack} from '@primer/react-brand/esm'

import {PlanTypeContext} from '../../_context/PlanTypeContext'

import {CompareTableGroup} from './CompareTableGroup/CompareTableGroup'
import {CompareTableHeader} from './CompareTableHeader/CompareTableHeader'
import type {CompareTableContent} from './content'

import styles from './styles.module.css'

type Props = {
  content: CompareTableContent
}

export function CompareTable({content}: Props) {
  const {planType} = use(PlanTypeContext)
  const {featureGroups, tableHeader} = content

  return (
    <section id="compare" className={styles.root}>
      <Grid className={styles.grid}>
        <Grid.Column span={12}>
          <div role="table" id={tableHeader?.content.fields.htmlId}>
            {tableHeader ? (
              <CompareTableHeader
                contentfulContent={tableHeader.content}
                columns={tableHeader.columns}
                planType={planType}
              />
            ) : null}

            <Stack direction="vertical" gap={32} padding="none">
              {featureGroups
                ? featureGroups.map(group => {
                    const {sys, fields} = group
                    const {content: rows, heading, htmlId} = fields

                    return (
                      <CompareTableGroup
                        key={sys.id}
                        heading={heading}
                        rows={rows}
                        planType={planType}
                        htmlId={htmlId}
                      />
                    )
                  })
                : null}
            </Stack>
          </div>
        </Grid.Column>
      </Grid>
    </section>
  )
}
